module.exports = __webpack_public_path__ + "static/media/Plant.54e1635f.svg";